var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"auto"},attrs:{"id":"app","tabindex":"0"},on:{"focus":_vm.cancelFocus}},[_c('keep-alive',[_c('Header')],1),_c('transition',{attrs:{"name":"app-transform"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }